import qs from 'query-string';
import { request } from 'api';
import { createTranscriptUrl } from '../transcript';
import {
  REDIRECT_WIDGET_KEY,
  URL_GENERATOR_V1_AUDIO_WIZARD_REDIRECT,
  URL_GENERATOR_V1_TRACE,
  URL_GENERATOR_V1_VIDEO_WIZARD_REDIRECT,
} from './constants';
import {
  AudioWizardRedirectRequest,
  UrlGeneratorTrace,
  VideoTranscriptionWizardRedirectRequest,
  VideoWizardRedirectRequest,
} from './types';

export function createHeadlinerVideoTranscriptionWizardRedirect({
  accessToken,
  videoUrl,
  aspectRatio,
  clipTitle,
  customTraceId,
  projectCuid,
  startWordId,
  endWordId,
}: VideoTranscriptionWizardRedirectRequest) {
  const transcriptUrl = createTranscriptUrl({
    accessToken,
    projectCuid,
    startWordId,
    endWordId,
  });

  return qs.stringifyUrl({
    url: URL_GENERATOR_V1_VIDEO_WIZARD_REDIRECT,
    query: {
      flow: 'videoSingleClip',
      videoUrl,
      transcriptUrl,
      clipTitle,
      customTraceId,
      defaultAspectRatio: aspectRatio,
      widgetKey: REDIRECT_WIDGET_KEY,
    },
  });
}

export function createHeadlinerAudioWizardRedirect({
  accessToken,
  aspectRatio,
  audioUrl,
  clipTitle,
  color,
  customTraceId,
  endWordId,
  imageUrl,
  projectCuid,
  startWordId,
  isClip,
}: AudioWizardRedirectRequest) {
  const transcriptUrl = createTranscriptUrl({
    accessToken,
    endWordId,
    projectCuid,
    startWordId,
  });

  return qs.stringifyUrl({
    url: URL_GENERATOR_V1_AUDIO_WIZARD_REDIRECT,
    query: {
      audioUrl,
      clipTitle,
      color,
      customTraceId,
      defaultAspectRatio: aspectRatio,
      imageUrl,
      transcriptUrl,
      widgetKey: REDIRECT_WIDGET_KEY,
      useAudioClipper: false,
      includeEdgeAssetShift: !isClip,
    },
  });
}

export function createHeadlinerVideoWizardRedirect({
  accessToken,
  videoUrl,
  clipTitle,
  customTraceId,
  endWordId,
  projectCuid,
  startWordId,
  isClip,
}: VideoWizardRedirectRequest) {
  const transcriptUrl = createTranscriptUrl({
    accessToken,
    endWordId,
    projectCuid,
    startWordId,
  });

  return qs.stringifyUrl({
    url: URL_GENERATOR_V1_VIDEO_WIZARD_REDIRECT,
    query: {
      videoUrl,
      clipTitle,
      customTraceId,
      transcriptUrl,
      widgetKey: REDIRECT_WIDGET_KEY,
      includeEdgeAssetShift: !isClip,
    },
  });
}

export async function getTraceById(traceId: string) {
  const { data } = await request.get<UrlGeneratorTrace>(
    `${URL_GENERATOR_V1_TRACE}/${traceId}`,
  );

  return data;
}
